export default __webpack_public_path__ + "static/media/icon-breifcase.68260bf2.svg";